import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../../stores/authStore';
// import { useLanguageSync } from '../../../hooks/useLanguageSync';
import { LanguageSwitcher } from '../../../components/LanguageSwitcher';

export function Header() {
  const { t } = useTranslation();
  const { user, isAuthenticated } = useAuthStore();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  // useLanguageSync();

  // Prevent body scroll when drawer is open
  // useEffect(() => {
  //   if (isDrawerOpen) {
  //     document.body.style.overflow = 'hidden';
  //   } else {
  //     document.body.style.overflow = '';
  //   }
  //   return () => {
  //     document.body.style.overflow = '';
  //   };
  // }, [isDrawerOpen]);

  const closeDrawer = () => setIsDrawerOpen(false);
  const toggleDrawer = () => setIsDrawerOpen((prev) => !prev);

  return (
    <header className="sticky top-0 left-0 right-0 z-50 bg-gray-900 border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center" onClick={closeDrawer}>
            <img
              src='/images/nutribot-logo.png'
              className='w-40 h-auto object-contain'
              alt='Nutribot Logo'
            />
            {/* <span className="text-2xl font-bold">
              <span className="text-yellow-400">Nutri</span>
              <span className="text-white">Bot</span>
            </span> */}
          </Link>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center space-x-8">
            <a
              href="#features"
              className="text-sm font-medium min-h-0 transition-colors duration-200 hover:text-yellow-400 text-gray-300 cursor-pointer"
            >
              {t('home.nav.features')}
            </a>
            <a
              href="#pricing"
              className="text-sm font-medium min-h-0 transition-colors duration-200 hover:text-yellow-400 text-gray-300 cursor-pointer"
            >
              {t('home.nav.pricing')}
            </a>
            <a
              href="#testimonials"
              className="text-sm font-medium min-h-0 transition-colors duration-200 hover:text-yellow-400 text-gray-300 cursor-pointer"
            >
              {t('home.nav.testimonials')}
            </a>
          </nav>

          {/* Desktop actions */}
          <div className="hidden md:flex items-center space-x-4">
            <LanguageSwitcher />

            {isAuthenticated ? (
              <Link to="/dashboard">
                <button className="px-6 py-2 text-sm rounded-lg bg-gradient-to-r from-yellow-400 to-yellow-600 text-black hover:from-yellow-500 hover:to-yellow-700 whitespace-nowrap cursor-pointer transition-ball font-semibold">
                  {t('home.nav.dashboard')}
                </button>
              </Link>
            ) : (
              <>
                <Link to="/login">
                  <button className="px-4 py-2 text-sm rounded-lg border border-gray-600 text-gray-300 hover:border-yellow-400 hover:text-yellow-400 whitespace-nowrap cursor-pointer transition-colors">
                    {t('home.hero.ctaLogin')}
                  </button>
                </Link>
                <Link to="/register">
                  <button className="px-4 py-2 text-sm rounded-lg bg-gradient-to-r from-yellow-400 to-yellow-600 text-black hover:from-yellow-500 hover:to-yellow-700 whitespace-nowrap cursor-pointer transition-ball">
                    {t('home.hero.ctaRegister')}
                  </button>
                </Link>
              </>
            )}
          </div>

          {/* Hamburger button */}
          <button
            className="md:hidden text-gray-300 hover:text-white transition-colors duration-200 cursor-pointer p-1"
            onClick={toggleDrawer}
            aria-label={isDrawerOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={isDrawerOpen}
          >
            <i
              className={`text-2xl transition-transform duration-300 ${isDrawerOpen
                ? 'ri-close-line rotate-90'
                : 'ri-menu-line rotate-0'
                }`}
              style={{ display: 'block', transform: isDrawerOpen ? 'rotate(90deg)' : 'rotate(0deg)' }}
            />
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      <div
        className={`md:hidden fixed left-0 right-0 overflow-hidden transition-ball duration-300 ease-in-out ${isDrawerOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          }`}
        aria-hidden={!isDrawerOpen}
      >
        <div className="bg-gray-900/95 backdrop-blur-md border-t border-gray-800 px-4 pt-4 pb-6 flex flex-col gap-4">
          {/* Nav links */}
          <nav className="flex flex-col gap-1">
            <a
              href="#features"
              onClick={closeDrawer}
              className="py-3 px-2 text-sm font-medium text-gray-300 hover:text-yellow-400 border-b border-gray-800 transition-colors duration-200 cursor-pointer"
            >
              {t('home.nav.features')}
            </a>
            <a
              href="#pricing"
              onClick={closeDrawer}
              className="py-3 px-2 text-sm font-medium text-gray-300 hover:text-yellow-400 border-b border-gray-800 transition-colors duration-200 cursor-pointer"
            >
              {t('home.nav.pricing')}
            </a>
            <a
              href="#testimonials"
              onClick={closeDrawer}
              className="py-3 px-2 text-sm font-medium text-gray-300 hover:text-yellow-400 border-b border-gray-800 transition-colors duration-200 cursor-pointer"
            >
              {t('home.nav.testimonials')}
            </a>
          </nav>

          {/* Language switcher */}
          <div className="px-2">
            <LanguageSwitcher />
          </div>

          {/* Auth buttons */}
          <div className="flex flex-col gap-3 px-2 pt-1">
            {isAuthenticated ? (
              <Link to="/dashboard" onClick={closeDrawer}>
                <button className="w-full px-6 py-2.5 text-sm rounded-lg bg-gradient-to-r from-yellow-400 to-yellow-600 text-black hover:from-yellow-500 hover:to-yellow-700 cursor-pointer transition-ball font-semibold">
                  {t('home.nav.dashboard')}
                </button>
              </Link>
            ) : (
              <>
                <Link to="/login" onClick={closeDrawer}>
                  <button className="w-full px-4 py-2.5 text-sm rounded-lg border border-gray-600 text-gray-300 hover:border-yellow-400 hover:text-yellow-400 cursor-pointer transition-colors">
                    {t('home.hero.ctaLogin')}
                  </button>
                </Link>
                <Link to="/register" onClick={closeDrawer}>
                  <button className="w-full px-4 py-2.5 text-sm rounded-lg bg-gradient-to-r from-yellow-400 to-yellow-600 text-black hover:from-yellow-500 hover:to-yellow-700 cursor-pointer transition-ball">
                    {t('home.hero.ctaRegister')}
                  </button>
                </Link>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Backdrop — rendered outside the header flow so it covers the page */}
      {isDrawerOpen && (
        <div
          className="md:hidden fixed inset-0 top-16 bg-black/50 z-[-1]"
          onClick={closeDrawer}
          aria-hidden="true"
        />
      )}
    </header>
  );
}